const AGOL_DOMAIN = '.maps.arcgis.com'

export function isValidUrl (str) {
  const regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-/]))?/
  if (!regex.test(str)) {
    return false
  } else {
    return true
  }
}

export function parseAGEUrl (portalUrl) {
  if (!isValidUrl(portalUrl)) {
    throw new Error('Invalid URL')
  }
  const parts = portalUrl.split('/')
  if (parts.length < 4) {
    throw new Error('Invalid Portal URL')
  }
  return `${parts[0]}//${parts[2]}/${parts[3]}`
}

export function parsePortalUrl (portalUrl, arcgisVersion) {
  if (arcgisVersion === 'AGOL') {
    const index = portalUrl.indexOf(AGOL_DOMAIN)
    if (index !== -1) {
      return portalUrl.substring(0, index + AGOL_DOMAIN.length)
    }
    return portalUrl
  } else {
    const parts = portalUrl.split('/')
    if (parts.length < 4) {
      return portalUrl
    }
    return `${parts[0]}//${parts[2]}/${parts[3]}`
  }
}

export function parseAGOLUrlKey (portalUrl) {
  if (!isValidUrl(portalUrl)) {
    throw new Error('Invalid URL')
  }
  let parts = portalUrl.split('/')
  if (parts.length < 3) {
    throw new Error('Invalid Portal URL')
  }
  parts = parts[2].split(AGOL_DOMAIN)
  if (parts.length < 2) {
    throw new Error('Invalid ArcGIS Online Portal URL')
  }
  return parts[0]
}

export function getIsAGE (portalUrl) {
  if (!isValidUrl(portalUrl)) {
    return false
  }
  return !portalUrl.includes(AGOL_DOMAIN) &&
    !portalUrl.includes('www.arcgis.com')
}

export function getIsAGOL (portalUrl) {
  if (!isValidUrl(portalUrl)) {
    return false
  }
  return portalUrl.includes(AGOL_DOMAIN)
}
